<!--
  Un workflow. Quien abre esta pantalla decide qué perfiles aprueban este tipo de solicitud, en qué
  orden, en quién cae cada devolución y quién puede rechazar. Lo que LLENA cada perfil no va aquí:
  lo fija el tipo de solicitud.
-->
<div class="kb-page kb-gateway">

  <nav class="kb-migas" aria-label="Ubicación">
    <a class="kb-miga" [routerLink]="['/console/workflows']">Workflows</a>
    <span class="kb-miga-sep" aria-hidden="true"><i class="fas fa-chevron-right"></i></span>
    <span class="kb-miga-actual">{{ w?.nombre || 'Workflow' }}</span>
  </nav>

  <div class="space-y-6" *ngIf="cargando" aria-hidden="true">
    <div class="kb-skeleton h-9 w-1/3"></div>
    <div class="kb-skeleton h-56 w-full"></div>
  </div>
  <p class="sr-only" *ngIf="cargando">Cargando el workflow.</p>

  <!-- No existe: es un hecho, no un fallo -->
  <div class="kb-aviso kb-aviso-info" *ngIf="!cargando && !w && noExiste">
    <i class="fas fa-info-circle mt-0.5" aria-hidden="true"></i>
    <div>
      <p class="kb-aviso-titulo">Ese workflow no existe</p>
      <p>Puede que se haya descartado. Los workflows que hay están en la lista.</p>
      <a class="kb-btn kb-btn-outline kb-btn-sm mt-3 !text-foreground" [routerLink]="['/console/workflows']">Ir a Workflows</a>
    </div>
  </div>
  <!-- Falló la consulta: se puede reintentar -->
  <div class="kb-aviso kb-aviso-peligro" *ngIf="!cargando && !w && !noExiste && error">
    <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i>
    <div>
      <p class="kb-aviso-titulo">No se pudo abrir el workflow</p>
      <p>{{ error }}</p>
      <button type="button" class="kb-btn kb-btn-outline kb-btn-sm mt-3" (click)="cargar()">
        <i class="fas fa-redo" aria-hidden="true"></i>Volver a consultar
      </button>
    </div>
  </div>

  <ng-container *ngIf="!cargando && w">

    <!-- ══ Cabecera ══════════════════════════════════════════════════════════════════════════ -->
    <div class="kb-page-header">
      <div>
        <h1 class="kb-page-title flex flex-wrap items-center gap-2">
          {{ w.nombre }}
          <span class="kb-badge kb-badge-exito" *ngIf="w.estado === 'PUBLICADO'">Publicado · v{{ w.version }}</span>
          <span class="kb-badge kb-badge-alerta" *ngIf="w.estado === 'BORRADOR'">Borrador · v{{ w.version }}</span>
          <span class="kb-badge kb-badge-neutro" *ngIf="w.estado === 'RETIRADO'">Retirado · v{{ w.version }}</span>
        </h1>
        <p class="kb-page-meta">
          Los perfiles que aprueban una solicitud de {{ w.tipo_nombre | lowercase }}, en orden.
          <ng-container *ngIf="w.publicado_at">Publicada el {{ fecha(w.publicado_at) }}<ng-container *ngIf="w.publicado_por"> por {{ w.publicado_por }}</ng-container>.</ng-container>
        </p>
      </div>

      <div class="flex flex-wrap items-center gap-2">
        <!-- Borrador: guardar, descartar (en dos pasos), publicar -->
        <ng-container *ngIf="editable">
          <ng-container *ngIf="!confirmandoDescarte">
            <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="confirmandoDescarte = true" [disabled]="guardando">
              <i class="fas fa-trash-alt" aria-hidden="true"></i>Descartar borrador
            </button>
            <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="guardar()" [disabled]="guardando || !sinGuardar || problemas.length">
              <i class="fas fa-save" aria-hidden="true"></i>Guardar cambios
            </button>
            <button type="button" class="kb-btn kb-btn-primary kb-btn-sm" (click)="publicar()" [disabled]="guardando || problemas.length">
              <i class="fas fa-check" aria-hidden="true"></i>Publicar la versión {{ w.version }}
            </button>
          </ng-container>
          <ng-container *ngIf="confirmandoDescarte">
            <span class="text-sm kb-texto-peligro">¿Descartar el borrador de la v{{ w.version }}? Se pierde lo que tiene.</span>
            <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="confirmandoDescarte = false" [disabled]="guardando">Cancelar</button>
            <button type="button" class="kb-btn kb-btn-danger kb-btn-sm" (click)="descartar()" [disabled]="guardando">
              <i class="fas fa-trash-alt" aria-hidden="true"></i>Sí, descartar la v{{ w.version }}
            </button>
          </ng-container>
        </ng-container>
        <!-- Publicado: editar abre la versión siguiente, o sigue el borrador que ya está -->
        <ng-container *ngIf="w.estado === 'PUBLICADO' && puedeConfigurar">
          <a class="kb-btn kb-btn-primary kb-btn-sm !text-primary-foreground" *ngIf="borradorAbierto" [routerLink]="['/console/workflows', borradorAbierto._id]">
            <i class="fas fa-pen" aria-hidden="true"></i>Seguir editando la v{{ borradorAbierto.version }}
          </a>
          <button type="button" class="kb-btn kb-btn-primary kb-btn-sm" *ngIf="!borradorAbierto" (click)="editar()" [disabled]="guardando">
            <i class="fas fa-pen" aria-hidden="true"></i>Editar (abre la versión {{ w.version + 1 }})
          </button>
        </ng-container>
        <a class="kb-btn kb-btn-outline kb-btn-sm !text-foreground"
           *ngIf="w.estado !== 'PUBLICADO' && publicadoVigente && !confirmandoDescarte" [routerLink]="['/console/workflows', publicadoVigente._id]">
          Ver la v{{ publicadoVigente.version }} publicada
        </a>
      </div>
    </div>

    <!-- ══ Avisos ════════════════════════════════════════════════════════════════════════════ -->
    <div class="kb-aviso kb-aviso-alerta" *ngIf="editable">
      <i class="fas fa-pen mt-0.5" aria-hidden="true"></i>
      <p>
        Estás editando la <strong>versión {{ w.version }}</strong>.
        <ng-container *ngIf="publicadoVigente">La v{{ publicadoVigente.version }} sigue rigiendo las solicitudes que ya empezaron;</ng-container>
        la v{{ w.version }} rige solo las que entren después de publicarla.
      </p>
    </div>
    <div class="kb-aviso kb-aviso-info" *ngIf="esBorrador && !puedeConfigurar">
      <i class="fas fa-eye mt-0.5" aria-hidden="true"></i>
      <p>Este es el borrador de la v{{ w.version }}. Puedes verlo, pero no cambiarlo: hace falta el permiso «Editar workflows».</p>
    </div>
    <div class="kb-aviso kb-aviso-info" *ngIf="w.estado === 'RETIRADO'">
      <i class="fas fa-archive mt-0.5" aria-hidden="true"></i>
      <p>Esta versión ya no rige. Se guarda porque la siguen usando las solicitudes que empezaron con ella, cuando las hay.</p>
    </div>
    <div class="kb-aviso kb-aviso-info" *ngIf="w.estado === 'PUBLICADO' && !puedeConfigurar">
      <i class="fas fa-eye mt-0.5" aria-hidden="true"></i>
      <p>Puedes ver este workflow, pero no cambiarlo. Para editarlo hace falta el permiso «Editar workflows».</p>
    </div>
    <div class="kb-aviso kb-aviso-peligro" *ngIf="error" role="alert">
      <i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i>
      <div>
        <p>{{ error }}</p>
        <ul class="mt-1 list-disc pl-5" *ngIf="detalle.length > 1"><li *ngFor="let d of detalle">{{ d }}</li></ul>
      </div>
    </div>
    <p class="text-sm font-medium kb-texto-exito" *ngIf="aviso" role="status">{{ aviso }}</p>

    <!-- ══ Las cifras (lo que el encabezado no dice) ═════════════════════════════════════════ -->
    <div class="kb-stat-grid">
      <div class="kb-stat"><div class="kb-stat-label wf-rotulo-cifra">Perfiles</div><div class="text-xl font-bold">{{ perfiles.length }}</div></div>
      <div class="kb-stat"><div class="kb-stat-label wf-rotulo-cifra">Pueden rechazar</div><div class="text-xl font-bold">{{ puedenRechazar }}</div></div>
      <div class="kb-stat"><div class="kb-stat-label wf-rotulo-cifra">Con devolución</div><div class="text-xl font-bold">{{ conDevolucion }}</div></div>
      <div class="kb-stat">
        <div class="kb-stat-label wf-rotulo-cifra">Solicitudes en curso con esta versión</div>
        <div class="text-xl font-bold">{{ w.solicitudes_en_curso ?? '—' }}</div>
      </div>
    </div>

    <!-- ══ La ruta ═══════════════════════════════════════════════════════════════════════════ -->
    <div class="kb-card">
      <div class="kb-card-header">
        <div>
          <p class="kb-seccion-rotulo">Por dónde pasa la solicitud</p>
          <p class="kb-card-desc">{{ editable ? 'Se dibuja sola con lo que configures abajo.' : 'Así la recorre la versión ' + w.version + '.' }}</p>
        </div>
      </div>
      <ol class="wf-ruta" aria-label="Ruta de la solicitud">
        <li class="wf-eslabon" *ngFor="let r of ruta; let ultimo = last">
          <div class="wf-caja"><p class="wf-caja-n">{{ r.nombre }}</p><p class="wf-caja-x">{{ r.extra }}</p></div>
          <i class="fas fa-arrow-right wf-flecha" aria-hidden="true" *ngIf="!ultimo"></i>
        </li>
      </ol>
    </div>

    <!-- ══ Lo que hace cada perfil (cómo trabaja el motor; no se configura) ═════════════════ -->
    <div class="kb-card">
      <div class="kb-card-header">
        <div>
          <p class="kb-seccion-rotulo">Lo que hace cada perfil cuando le llega la solicitud</p>
          <p class="kb-card-desc">Son las reglas comunes a cualquier etapa: valen igual para los cuatro perfiles y no se cambian desde aquí. La tarea de cada uno ya está en la tabla de perfiles, más abajo.</p>
        </div>
      </div>
      <div class="wf-hace">
        <div class="wf-hace-i"><p class="wf-hace-t">Tomarla</p><p>El primero del perfil que la toma la tiene; nadie más con ese perfil puede tomarla. Si la suelta, vuelve a la bandeja.</p></div>
        <div class="wf-hace-i"><p class="wf-hace-t">Comentar</p><p>Solo quien la tiene comenta, las veces que haga falta. Cada comentario queda en su etapa, con fecha y nombre.</p></div>
        <div class="wf-hace-i"><p class="wf-hace-t">Decidir con un comentario</p><p>Aprobar, devolver o rechazar. La decisión es el comentario que la pasa al siguiente; rechazar lleva además el motivo.</p></div>
        <div class="wf-hace-i wf-apagado"><p class="wf-hace-t">Plazo por perfil <span class="kb-badge kb-badge-contorno">más adelante</span></p><p>Cuántos días tiene cada perfil. El reloj se detendrá mientras se espera al comercio.</p></div>
      </div>
    </div>

    <!-- ══ Los perfiles ══════════════════════════════════════════════════════════════════════ -->
    <div class="kb-card">
      <div class="kb-card-header">
        <div>
          <p class="kb-seccion-rotulo">Perfiles · {{ perfiles.length }}, en orden</p>
          <p class="kb-card-desc">
            Cada perfil recibe la solicitud del anterior y, al aprobar, la pasa siempre al siguiente.
            {{ editable ? 'Por cada uno decides en quién cae cuando devuelve y si puede rechazar; el orden se cambia con las flechas.' : 'Por cada uno se ve en quién cae cuando devuelve y si puede rechazar.' }}
          </p>
        </div>
      </div>

      <div class="wf-fila wf-enc" aria-hidden="true">
        <span></span><span>Perfil</span><span>Al aprobar pasa a</span><span>Al devolver cae en</span><span>Puede rechazar</span><span></span>
      </div>

      <div class="wf-fila" [class.wf-fila-lectura]="!editable" *ngFor="let p of perfiles; let i = index; let ultimo = last">
        <span class="wf-orden">{{ i + 1 }}</span>

        <div class="wf-campo">
          <label class="wf-rot" [for]="'wfRol' + i">Perfil</label>
          <div class="kb-select-envoltorio" *ngIf="editable">
            <select [id]="'wfRol' + i" class="kb-select" [ngModel]="p.rol" (ngModelChange)="cambiarRol(i, $event)">
              <option *ngFor="let r of roles" [value]="r._id" [disabled]="rolUsado(r._id, i)">{{ r.nombre }}{{ rolUsado(r._id, i) ? ' (ya está)' : '' }}</option>
            </select>
            <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
          </div>
          <p class="text-sm font-medium" *ngIf="!editable">{{ nombreRol(p.rol) }}</p>
          <!-- La tarea de este perfil en su etapa (certificación de experiencia, W-01): no se
               configura acá, la fija el tipo de solicitud; solo se muestra. -->
          <p class="text-xs text-muted-foreground mt-0.5" *ngIf="tareaDe(i)">{{ tareaDe(i) }}</p>
        </div>

        <div class="wf-campo">
          <span class="wf-rot">Al aprobar pasa a</span>
          <p class="text-sm" [class.font-medium]="ultimo">{{ alAprobar(i) }}</p>
        </div>

        <div class="wf-campo">
          <label class="wf-rot" [for]="'wfDev' + i">Al devolver cae en</label>
          <div class="kb-select-envoltorio" *ngIf="editable && i > 0">
            <select [id]="'wfDev' + i" class="kb-select" [ngModel]="p.devuelve_a === null ? '' : '' + p.devuelve_a" (ngModelChange)="cambiarDevuelve(i, $event)">
              <option value="">No puede devolver</option>
              <option *ngFor="let q of perfiles.slice(0, i); let k = index" [value]="'' + (k + 1)">{{ nombreRol(q.rol) }}</option>
            </select>
            <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
          </div>
          <p class="text-sm text-muted-foreground" *ngIf="editable && i === 0">No devuelve (es el primero)</p>
          <p class="text-sm" *ngIf="!editable">{{ p.devuelve_a === null ? (i === 0 ? 'No devuelve (es el primero)' : 'No puede devolver') : nombreRol(perfiles[p.devuelve_a - 1]?.rol || '') }}</p>
        </div>

        <div class="wf-campo">
          <span class="wf-rot">Puede rechazar</span>
          <label class="wf-sw" [for]="'wfRec' + i" *ngIf="editable">
            <input type="checkbox" [id]="'wfRec' + i" [ngModel]="p.puede_rechazar" (ngModelChange)="cambiarRechaza(i, $event)">
            <span class="wf-pista" aria-hidden="true"></span>
            <span>{{ p.puede_rechazar ? 'Sí' : 'No' }}</span>
          </label>
          <p class="text-sm" *ngIf="!editable">{{ p.puede_rechazar ? 'Sí' : 'No' }}</p>
        </div>

        <div class="wf-mover" *ngIf="editable">
          <button type="button" class="kb-btn kb-btn-ghost kb-btn-icon" (click)="subir(i)" [disabled]="i === 0" [attr.aria-label]="'Subir ' + nombreRol(p.rol)"><i class="fas fa-arrow-up"></i></button>
          <button type="button" class="kb-btn kb-btn-ghost kb-btn-icon" (click)="bajar(i)" [disabled]="ultimo" [attr.aria-label]="'Bajar ' + nombreRol(p.rol)"><i class="fas fa-arrow-down"></i></button>
          <button type="button" class="kb-btn kb-btn-ghost kb-btn-icon" (click)="sacar(i)" [disabled]="perfiles.length <= 1" [attr.aria-label]="'Quitar ' + nombreRol(p.rol)"><i class="fas fa-times"></i></button>
        </div>
      </div>

      <!-- El fin no es un paso más (Juan, 28-sep): se dice en una frase, sin marca de etapa. -->
      <p class="text-sm text-muted-foreground px-6 py-3 m-0">Cuando aprueba el último perfil, {{ (w.fin_descripcion || 'termina el workflow.') | lowercase }}</p>

      <div class="wf-pie" *ngIf="editable">
        <div class="flex items-center gap-2">
          <div class="kb-select-envoltorio">
            <label class="sr-only" for="wfAgregar">Perfil para agregar</label>
            <select id="wfAgregar" class="kb-select" [(ngModel)]="rolAgregar">
              <option value="">Agregar un perfil…</option>
              <option *ngFor="let r of rolesLibres" [value]="r._id">{{ r.nombre }}</option>
            </select>
            <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
          </div>
          <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="agregar()" [disabled]="!rolAgregar">
            <i class="fas fa-plus" aria-hidden="true"></i>Agregar
          </button>
        </div>
        <div class="flex items-center gap-3">
          <p class="text-sm kb-texto-alerta" *ngIf="problemas.length">{{ problemas[0] }}</p>
          <p class="text-sm kb-texto-alerta" *ngIf="!problemas.length && sinGuardar">Tienes cambios sin guardar.</p>
          <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" *ngIf="sinGuardar" (click)="deshacer()">Deshacer los cambios</button>
        </div>
      </div>
    </div>

    <!-- ══ Versiones ═════════════════════════════════════════════════════════════════════════ -->
    <p class="text-xs text-muted-foreground" *ngIf="versiones.length > 1">
      Versiones:
      <ng-container *ngFor="let v of versiones; let ultimaV = last">
        <strong class="text-foreground" *ngIf="v._id === w._id">v{{ v.version }} {{ v.estado === 'PUBLICADO' ? 'publicada' : v.estado === 'BORRADOR' ? 'en borrador' : 'retirada' }}</strong>
        <a class="!text-foreground underline-offset-2 hover:underline" *ngIf="v._id !== w._id" [routerLink]="['/console/workflows', v._id]">v{{ v.version }} {{ v.estado === 'PUBLICADO' ? 'publicada' : v.estado === 'BORRADOR' ? 'en borrador' : 'retirada' }}</a><span *ngIf="!ultimaV"> · </span>
      </ng-container>
    </p>

  </ng-container>
</div>
